module.exports = __webpack_public_path__ + "static/our-firm-2-a2be862e3f22f75e6a290fa5d5e864c0.jpg";